"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _modal = _interopRequireDefault(require("../modal"));

var _index = _interopRequireDefault(require("../form-footer/index"));

var _button = _interopRequireDefault(require("../button"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_style["default"]);

var ModalAlert = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ModalAlert, _React$PureComponent);

  var _super = _createSuper(ModalAlert);

  function ModalAlert() {
    var _this;

    _classCallCheck(this, ModalAlert);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      fetching: false,
      confirmed: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeydown", function (e) {
      var confirmed = _this.state.confirmed;
      var _this$props = _this.props,
          confirmationEl = _this$props.confirmationEl,
          submitByEnter = _this$props.submitByEnter;

      if (!submitByEnter) {
        return;
      }

      var isConfirmed = confirmationEl ? confirmed : true;

      if (e.keyCode === 13) {
        e.preventDefault();

        if (isConfirmed) {
          _this.handleSubmit();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleFetching", function () {
      return _this.setState({
        fetching: !_this.state.fetching
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setConfirmed", function (value) {
      var confirmationHandler = _this.props.confirmationHandler;

      _this.setState({
        confirmed: value
      });

      if (confirmationHandler) {
        _this.toggleFetching();

        confirmationHandler().then(function () {
          return _this.toggleFetching();
        })["catch"](function () {
          return _this.toggleFetching();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clearState", function () {
      _this.setState({
        fetching: false,
        confirmed: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDiscard", function () {
      _this.clearState();

      _this.props.onDiscard();
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function () {
      var _this$props2 = _this.props,
          onSubmit = _this$props2.onSubmit,
          closeAfterSubmit = _this$props2.closeAfterSubmit;

      _this.toggleFetching();

      var submitResult = onSubmit(_this.state.confirmed);
      Promise.resolve(submitResult).then(function () {
        return _this.handleClose(closeAfterSubmit);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      var close = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      _this.clearState();

      close && _this.props.onClose();
    });

    return _this;
  }

  _createClass(ModalAlert, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('keydown', this.handleKeydown, true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.handleKeydown, true);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          icon = _this$props3.icon,
          title = _this$props3.title,
          description = _this$props3.description,
          discard = _this$props3.discard,
          submit = _this$props3.submit,
          submitAppearance = _this$props3.submitAppearance,
          confirmationEl = _this$props3.confirmationEl,
          modalDiscardDataID = _this$props3.modalDiscardDataID,
          modalSubmitDataID = _this$props3.modalSubmitDataID,
          _this$props3$compactF = _this$props3.compactFooter,
          compactFooter = _this$props3$compactF === void 0 ? false : _this$props3$compactF,
          rest = _objectWithoutProperties(_this$props3, ["icon", "title", "description", "discard", "submit", "submitAppearance", "confirmationEl", "modalDiscardDataID", "modalSubmitDataID", "compactFooter"]);

      return /*#__PURE__*/React.createElement(_modal["default"], _extends({}, rest, {
        onClose: this.handleClose,
        hideCloseBtn: true
      }), /*#__PURE__*/_jsx(React.Fragment, {}, void 0, /*#__PURE__*/_jsx("div", {
        className: cx('modal-alert')
      }, void 0, icon && /*#__PURE__*/_jsx("img", {
        className: cx('modal-alert__icon'),
        src: icon
      }), /*#__PURE__*/_jsx("div", {
        className: cx('modal-alert__title')
      }, void 0, title), /*#__PURE__*/_jsx("div", {
        className: cx('modal-alert__description')
      }, void 0, description), submit && confirmationEl && /*#__PURE__*/_jsx("div", {
        className: cx('modal-alert__confirmation')
      }, void 0, confirmationEl({
        value: this.state.confirmed,
        onChange: this.setConfirmed
      }))), (discard || submit) && /*#__PURE__*/_jsx(_index["default"], {
        compact: compactFooter
      }, void 0, discard && /*#__PURE__*/_jsx(_button["default"], {
        appearance: "outline",
        onClick: function onClick() {
          return _this2.handleDiscard() || _this2.handleClose();
        },
        "data-id": modalDiscardDataID
      }, void 0, discard), submit && /*#__PURE__*/_jsx(_button["default"], {
        appearance: submitAppearance,
        disabled: confirmationEl && !this.state.confirmed,
        fetching: this.state.fetching,
        onClick: this.handleSubmit,
        "data-id": modalSubmitDataID
      }, void 0, submit))));
    }
  }]);

  return ModalAlert;
}(React.PureComponent);

_defineProperty(ModalAlert, "defaultProps", {
  compactFooter: false,
  closeAfterSubmit: true,
  submitByEnter: false,
  fetching: false,
  isOpen: false,
  icon: null,
  discard: null,
  submit: null,
  onClose: function onClose() {
    return void 0;
  },
  onSubmit: function onSubmit() {
    return void 0;
  },
  onDiscard: function onDiscard() {
    return void 0;
  }
});

var _default = ModalAlert;
exports["default"] = _default;